<div class="d-flex align-items-center justify-content-center scroll-to-complete {{ containerClass }}" (click)="onContentClicked($event)">
  <div class="d-flex flex-column align-items-center scroll-to-complete__content">
    <label class="text-pink">{{ label }}</label>
    <span class="scroll-to-complete__content__arrow">
      <i class="icon-collapse icon-chevron-down ng-star-inserted"></i>
    </span>
  </div>
</div>
